





import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class ManagementCustomProperty extends Vue {
  private get remoteSrc() {
    const queryObject = { 
      serviceType: 'PREMIUM',
      displayOrder: this.$route.query.displayOrder?.toString() || '',
      propertyNo: this.$route.query.propertyNo?.toString() || '',
    };
    const queryString = new URLSearchParams(queryObject).toString();
    
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/management-custom-property' + '?' + queryString;
  }
}
